import PostFilter from '../classes/postFilter';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {

    // eslint-disable-next-line no-undef
    let ajaxObj = content;

    // JavaScript to be fired on the home page, after the init JS
    let $cat = $('.blog-category');
    let $reset = $('.blog-category__reset');
    let mobBreak = 767;
    //let ipadBreak = 991;
    let matchHeightOptions = {
      byRow: true,
      property: 'height', 
      target: null, 
      remove: false,
    };


    var options = {
       postType: 'post',
       postsPerPage: -1,
       categories: [],
       ajaxObj : ajaxObj,
       ajaxMethod : 'filter_tips_and_info_sheets',
       categoryNotIn: [24],
    };

    let postFilter = new PostFilter(options);


    $reset.on('click', function(e){ 
      e.preventDefault();
      $cat.removeClass('active');
      postFilter.resetCats();
      closeMobileCats();
      let $this = $(this);

      postFilter.filter(
         function() {
          $(document).trigger('loadingTipSheets');
             $this.addClass('active');
         },
         function(data) {
             $('.blog-list').html(data);
               setTimeout(function(){
                $(document).trigger('tipSheetsLoaded');
                $this.addClass('active');
                $('.blog-list__item').matchHeight(matchHeightOptions);
             }, 1000);   
         }
      );
    });



  

    $cat.on('click', function(e) {
       
       e.preventDefault();

       $reset.removeClass('active');

       ($(this).hasClass('active') ? $(this).removeClass('active') : $(this).addClass('active'));

       var $catList = [];
       var activeFilter = false;
       
       $cat.each(function() { 
          let $catID = $(this).data('id');
          if($(this).hasClass('active')) {
             $catList.push($catID);
             activeFilter = true;  
          }
       });
       console.log(activeFilter);
       closeMobileCats();




       if(activeFilter == false) {
        //
        $('.blog-category__reset').addClass('active');
       }

       postFilter.setCatsAndFilter(
          $catList, 
           function(){
              $(document).trigger('loadingTipSheets');
           }, 
           function(data){
              $('.blog-list').html(data);
              $(document).find('.blog-list__item').matchHeight();
              setTimeout(function(){
                 $(document).trigger('tipSheetsLoaded');
                 $('.blog-list__item').matchHeight(matchHeightOptions);
              }, 1000);  
           }
        );

    });


    $(document).on('loadingTipSheets', function(){
       launchLoader('.blog-wrap');
       $('.blog-list').addClass('out');
    });

    $(document).on('tipSheetsLoaded', function(){
       hideLoader('.blog-wrap');
       $('.blog-list').removeClass('out');
    });

    function launchLoader($el) {
       $($el).find('.assure-loader').addClass('assure-loader__in');
    }

    function hideLoader($el) {
       $($el).find('.assure-loader').removeClass('assure-loader__in');
    }


    $(window).resize(function(){ 
      checkFilterMenu();
    });
    setTimeout(function(){
       checkFilterMenu();
    }, 1000);
    

    function checkFilterMenu() {
       
       let $w = $(document).width();
       let $columnHeight = parseInt($('.blog-categories__column').outerHeight()) ;
       let $blogCats = $('.blog-categories__column');
       //+ parseInt($('.blog-categories-mobile').outerHeight()

       if($w <= mobBreak) {
          $blogCats.css('top', -$columnHeight + 'px'); 
       } 

       if($w > mobBreak) {
        $blogCats.css('top', 'unset');
       }

    }

    $('.blog-categories-mobile p').on('click', function(){
       $(this).toggleClass('in');
       $('.blog-categories__column').toggleClass('in');
    });

    function closeMobileCats() {
       $(this).removeClass('in');
       $('.blog-categories__column').removeClass('in');
    }




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/blog.js